<div class="app-paginated-table-container">
  @if(filterDefs) {
    <div class="filter-panel-container">
      <app-filter-panel
        [filterDefs]="filterDefs"
        (filterQueryParameterChange)="onFilterQueryParameterChange($event)"
        [isLoading]="isLoading">
      </app-filter-panel>
    </div>
  }
  <p-table #pTable
    [columns]="columns"
    [value]="value"
    [lazy]="true"
    [lazyLoadOnInit]="false"
    (onLazyLoad)="onLazyLoad($event)"
    [loading]="isLoading"
    [paginator]="true"
    [rows]="pageSize"
    [rowsPerPageOptions]="pageSizeOptions"
    [totalRecords]="totalItemCount"
    [resizableColumns]="true"
    columnResizeMode="expand"
    [reorderableColumns]="true"
    [tableStyle]="{ 'width': '100%', 'table-layout': 'fixed' }"
    styleClass="p-datatable-sm"
    [totalRecords]="totalRecords"
    selectionMode="multiple"
    [selection]="selection"
    (selectionChange)="onSelectionChange($event)"
    [selectAll]="selectAll"
    (selectAllChange)="onSelectAllChange($event)"
    [rowGroupMode]="rowGroupMode"
    [groupRowsBy]="groupRowsBy"
    [sortField]="orderKey"
    [sortOrder]="orderAsc ? 1 : -1"
    >
    <ng-template pTemplate="header" let-columns>
      <tr>
        <th class="check-box-header">
          <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
        </th>
        @if (rowMenuItems && rowMenuItems.length > 0) {
          <th class="row-menu-header"></th>
        }
        @for (column of getVisibleColumns(); track column) {
          <th
            [pSortableColumn]="column.columnDef.orderKey"
            [pSortableColumnDisabled]="!column.columnDef.orderKey"
            pResizableColumn
            pReorderableColumn
            [width]="column.columnDef.width"
            >
            <div class="header-cell">
              <div class="header-cell-title">{{ column.columnDef.label }}</div>
              @if (column.columnDef.orderKey) {
                <p-sortIcon [field]="column.columnDef.orderKey"></p-sortIcon>
              }
            </div>
          </th>
        }
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-item let-columns="columns">
      <tr (click)="onRowClick(item)">
        <td>
          <p-tableCheckbox [value]="item"></p-tableCheckbox>
        </td>
        @if (rowMenuItems && rowMenuItems.length > 0) {
          <td>
            <p-button link (click)="showRowMenu(item, $event)" class="row-menu-button" icon="pi pi-ellipsis-v"/>
          </td>
        }
        @for (column of getVisibleColumns(); track column) {
          <td>
            @if (column.columnDef.template || column.columnDef.cellType) {
              <ng-container *ngTemplateOutlet="getTemplate(column.columnDef); context:{item: item, column: column.columnDef}"></ng-container>
            } @else {
              {{ dig(item, column.columnDef.attr) }}
            }
            <ng-template #defaultCellContent>
              {{ dig(item, column.columnDef.attr) }}
            </ng-template>
          </td>
        }
      </tr>
    </ng-template>
    <ng-template pTemplate="paginatorleft">
      <!-- This empty tag is needed to center the pagination bar -->
    </ng-template>
    <ng-template pTemplate="paginatorright">
      <div class="table-settings-icon" (click)="onSettingsIconClick($event)">&#9881;</div>
    </ng-template>
    <ng-template pTemplate="groupheader" let-item>
      <tr pRowGroupHeader>
          <th [attr.colspan]="getVisibleColumns().length">
              <div class="flex items-center gap-2">
                  <span class="font-bold">
                    {{ groupRowsBy !== undefined ? dig(item, groupRowsBy) : '' }}
                  </span>
              </div>
          </th>
      </tr>
    </ng-template>
  </p-table>

  <ng-template #dateCellTemplate let-item="item" let-column="column">
    {{ dig(item, column.attr) | date }}
  </ng-template>

  <ng-template #booleanCellTemplate let-item="item" let-column="column">
    {{ dig(item, column.attr) ? '&check;' : '&#65794;' }}
  </ng-template>

  <p-menu #rowMenu [model]="rowMenuItems" [popup]="true" />

  <p-dialog [modal]="true" [(visible)]="tableSettingsDialogVisible" [style]="{ margin: '10px' }">
    <ng-template pTemplate="header">
      <h1 i18n="table|Table settings dialog header">Table settings</h1>
    </ng-template>
    <div class="table-settings-container">
      <h2 i18n="table|Show columns header">Show Columns</h2>
      <div class="show-columns-container">
        <ul>
          @for (column of columns; track column; let idx = $index) {
            <li>
              @let checkboxInputId = 'column-checkbox-' + idx;
              <p-checkbox [inputId]="checkboxInputId" [binary]="true" [(ngModel)]="column.visible"></p-checkbox>
              <label [for]="checkboxInputId">{{ column.columnDef.label }}</label>
            </li>
          }
        </ul>
      </div>
    </div>
  </p-dialog>
</div>
